import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Expertise from "@/components/site/Expertise";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Testimonials from "@/components/site/Testimonials";
import Insights from "@/components/site/Insights";
import FAQ, { FAQS } from "@/components/site/FAQ";
import { HomeImpact } from "@/components/site/Impact";
import {
  OurApproach,
  WhyBlezzings,
  ProblemsWeSolve,
  FocusedSolutions,
  HomeIndustries,
  HomeLeadership,
} from "@/components/site/HomeNarrative";
import BookConsultationDialog from "@/components/site/BookConsultationDialog";
import JoinUsDialog from "@/components/site/JoinUsDialog";
import FloatingActions from "@/components/site/FloatingActions";
import HomeTools from "@/components/site/HomeTools";
import { track } from "@/lib/analytics";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home() {
  const [bookOpen, setBookOpen] = useState(false);
  const [joinOpen, setJoinOpen] = useState(false);
  const { hash } = useLocation();

  usePageMeta({
    title: "Sales & Marketing Consultants Bengaluru, India | BLEZZINGS",
    description:
      "Bengaluru-based sales and marketing consultants helping D2C, FMCG, consumer durables and B2B businesses grow profitably — strategy through execution.",
    canonical: "https://blezzings.co/",
    faqs: FAQS,
    professionalService: true,
  });

  useEffect(() => {
    // Reset only on mount — keep default title if a sub-brand page cleaned up.
    document.title = "Sales & Marketing Consultants Bengaluru, India | BLEZZINGS";
  }, []);

  // When navigating in from another page with a hash (e.g. footer link to
  // /#faq from /businesses/academy), scroll to that section once the page has
  // rendered.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const target = document.getElementById(id);
    if (target) {
      // small delay so any lazy-loaded sections settle before scrolling
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    }
  }, [hash]);

  const openBook = (source = "unknown") => {
    track("book_consultation_open", { source });
    setBookOpen(true);
  };
  const openJoin = (source = "unknown") => {
    track("join_us_open", { source });
    setJoinOpen(true);
  };

  return (
    <div data-testid="home-page" className="relative">
      <Nav onBook={() => openBook("nav")} />
      <Hero onBook={() => openBook("hero")} />
      <HomeImpact />
      <ProblemsWeSolve />
      <FocusedSolutions />
      <Expertise />
      <WhyBlezzings />
      <OurApproach />
      <HomeIndustries />
      <HomeLeadership />
      <Testimonials />
      <FAQ />
      <Insights />
      <HomeTools />
      <Contact onBook={() => openBook("contact")} />
      <Footer onJoin={() => openJoin("footer")} />
      <FloatingActions onBook={() => openBook("floating")} />
      <BookConsultationDialog open={bookOpen} onOpenChange={setBookOpen} />
      <JoinUsDialog open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
